export default [
  {
    "name-uz": "Kutilyapti",
    "name-ru": "Ожидается",
    "name-en": "Waiting",
    id: "DRAFT",
  },
  {
    "name-uz": "Qabul qilingan",
    "name-ru": "Принятый",
    "name-en": "Accepted",
    id: "ACCEPTED",
  },
  {
    "name-uz": "Qaytarilgan",
    "name-ru": "Возвращенный",
    "name-en": "rejected",
    id: "REJECTED",
  },
  {
    "name-uz": "Kutilyapti",
    "name-ru": "Ожидаемый",
    "name-en": "Waiting",
    id: "SUBMITTED",
  },
  {
    "name-uz": "Tavsiya qilingan",
    "name-ru": "Зачислен",
    "name-en": "Enrolled",
    id: "PASSED",
  },
  {
    "name-uz": "Tavsiya qilinmagan",
    "name-ru": "Не Зачислен",
    "name-en": "Failed",
    id: "FAILED",
  },
  {
    "name-uz": "Imtixon topshirgan",
    "name-ru": "Examined",
    "name-en": "Examined",
    id: "EXAMINED",
  },
];
